import { Inventory } from './../invetory.reducer';
import { FETCH_ALL_DESTINATION_REQUESTED } from './../../destination/destination.action';
import { Router } from '@angular/router';
import { NotificationService } from './../../../common/services/notification/notification.service';
import { Exception } from './../../../common/exceptions/exception';
import { ActivatedRoute, Params } from '@angular/router';
import { ApiService } from './../../../api/api.service';
import { Component, OnInit, ViewChild, AfterViewInit, DoCheck, ElementRef } from '@angular/core';
import store from './../../../store/store.module';
import * as _ from 'lodash';
import {
  UPDATE_PRODUCT_DESTINATION,
  UPDATE_PRODUCT_LOCATION,
  SAVE_PRODUCT_LOCATION,
  UPDATE_MULTI_PRODUCT_LOCATION_REQUESTED,
  DETECT_TYPE_OF_CODE_REQUESTED,
  SKIP_DISPUTE_ITEM
} from './batch.actions';
import { LOCATION_COMPONENT_UPDATE_DESTINATION_FILTER } from '../../location/list/list.action';
import { FETCH_DESTINATION_DETAIL_REQUESTED } from '../../destination/edit/edit.action';
import {UtilityService} from "../../../common/services/utility/utility.service";
import Redirect from "../../../models/Redirect";
import {PRODUCT_CREATE_COMP} from "../../product/product.const";

@Component({
  selector: 'app-batch',
  templateUrl: './batch.component.html',
  styleUrls: ['./batch.component.scss']
})
export class BatchComponent implements OnInit {
  @ViewChild('searchInput') searchInput: ElementRef;

  public store = store;

  public selectedDestination;
  public selectedLocation;
  protected isSelectedDest = false;
  public searchValue = '';

  public selectAll = false;
  public detech_code = false;
  public UPDATE_PRODUCT_DESTINATION = UPDATE_PRODUCT_DESTINATION;
  public UPDATE_PRODUCT_LOCATION = UPDATE_PRODUCT_LOCATION;
  public SAVE_PRODUCT_LOCATION = SAVE_PRODUCT_LOCATION;

  public destination: any = {};
  public location;

  constructor(
    private api: ApiService,
    private activatedRoute: ActivatedRoute,
    private notification: NotificationService,
    private router: Router,
    private utilityService: UtilityService
  ) { }

  ngOnInit() {
    this.detech_code = false;
    this.searchValue = store.getState().Inventory.batch.originalText;
    if (this.searchValue) {
      this.onSubmit(null);
    }
  }
  skipItem(code) {
    store.dispatch({ type: SKIP_DISPUTE_ITEM, data: code});
  }
  createNewLocation(code) {
    this.utilityService.nextPageWithReferer(['/location/create'], new Redirect(this.router.url, {
      code
    }));
  }
  onSubmit(form) {
    let product_skus = [];
    if (!_.isUndefined(this.activatedRoute.snapshot.queryParams.sku) && this.activatedRoute.snapshot.queryParams.sku !== '') {
      product_skus = this.activatedRoute.snapshot.queryParams.sku.split(',');
    }
    let value = this.searchValue.toUpperCase().replace(/[^A-z0-9]+/g, ',');
    const codes = value.split(',');
    this.detech_code = true;
    store.dispatch({ type: DETECT_TYPE_OF_CODE_REQUESTED, data: codes, originalText: this.searchValue});
  }

  saveProductHasLocation(item) {
    let params = {
      product_sku: item.getSku(),
      destination_id: item.destination.getId(),
      location_id: item.location.getId()
    };
    store.dispatch({ type: SAVE_PRODUCT_LOCATION, data: params, com: 'BULK_UPDATE' });
  }

  saveProductLocation(item) {
    if (_.isNil(item.destination)) {
      this.notification.show('warning', 'Please select New Destination', 3000);
      return false;
    }
    if (_.isNil(item.location)) {
      this.notification.show('warning', 'Please select New Location', 3000);
      return false;
    }
    let params = {
      product_sku: item.getSku(),
      destination_id: item.destination.getId(),
      location_id: item.location.getId()
    };
    store.dispatch({ type: SAVE_PRODUCT_LOCATION, data: params, com: 'BULK_UPDATE' });
    item.current_destination = item.destination;
    item.current_location = item.location;
  }

  saveAll() {
    let has_location = _.find(store.getState().Inventory.batch.codes, { kind: 'location' });
    if (!_.isNil(has_location)) {
      const products = _.filter(store.getState().Inventory.batch.codes, item => item.kind === 'product');
      let data = _.map(products, item => {
        return {
          product_sku: item.data.getSku(),
          destination_id: item.data.destination_id,
          location_id: item.data.location_id
        };
      });
      store.dispatch({
        type: UPDATE_MULTI_PRODUCT_LOCATION_REQUESTED,
        data: data,
        com: 'BULK_UPDATE'
      });
    } else {
      if (!_.isNil(this.destination) && !_.isNil(this.destination.id)) {
        const products = _.filter(store.getState().Inventory.batch.codes, item => item.kind === 'product');
        let data = _.map(products, item => {
          return {
            product_sku: item.data.getSku(),
            destination_id: this.destination.id
          };
        });
        if (!_.isNil(this.location)) {
          data = _.map(data, item => {
            item.location_id = this.location.id;
            return item;
          });
        }
        store.dispatch({
          type: UPDATE_MULTI_PRODUCT_LOCATION_REQUESTED,
          data: data,
          com: 'BULK_UPDATE'
        });
      }
    }
  }
}
